import React from 'react';
import { useQuery } from '@apollo/client';
import ReactSelect from 'components/Fields/ReactSelect';
import { Field } from 'formik';
import { COUNTRY_LISTS } from 'pages/MarketListing/MarketListingGraphQL';
import { Col } from 'reactstrap';

const CallingCodeField = ({
  name,
  label,
  id,
  // required = false,
  disabled = false,
}) => {
  const { data: countryCurrencies } = useQuery(COUNTRY_LISTS, {
    fetchPolicy: 'network-only',
  });

  // Sort the countryCurrencies array by callingCode
  // const sortedCountryCurrencies = countryCurrencies?.countryCurrencies?.sort(
  //   (a, b) => a.callingCode.localeCompare(b.callingCode)
  // );

  return (
    <Col className="phone-code-column">
      <div className="form-label">{label}</div>
      {/* {required && <span style={{ color: 'red' }}>*</span>} */}
      <Field
        id={id}
        name={name}
        label={label}
        type="select"
        isSearchable
        component={ReactSelect}
        data={countryCurrencies?.countryCurrencies || []}
        keys={{ id: 'id', label: 'callingCode' }}
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => option.callingCode}
        isDisabled={disabled}
        placeholder="Calling Code"
      />
    </Col>
  );
};

export default CallingCodeField;
